import React from 'react';
import { calculateEdgePath, getEdgeConnectionPoints } from './GraphLayout';
import './GraphEdge.css';

/**
 * GraphEdge Component
 * Represents a directed edge between two nodes (SVG path)
 */
function GraphEdge({ edge, fromPos, toPos, isHighlighted, nodeWidth, nodeHeight }) {
  const { id, from, to, label, messageCount } = edge;
  
  const path = calculateEdgePath(fromPos, toPos, nodeWidth, nodeHeight);
  const connectionPoints = getEdgeConnectionPoints(fromPos, toPos, nodeWidth, nodeHeight);
  
  // Arrow head marker
  const markerId = `arrowhead-${id}`;
  
  return (
    <g className={`graph-edge ${isHighlighted ? 'highlighted' : ''}`}>
      <defs>
        <marker
          id={markerId}
          markerWidth="8"
          markerHeight="8"
          refX="9"
          refY="3"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path
            d="M0,0 L0,6 L9,3 z"
            fill={isHighlighted ? '#4A90E2' : '#7F8C8D'}
            stroke={isHighlighted ? '#4A90E2' : '#7F8C8D'}
          />
        </marker>
      </defs>
      
      <path
        d={path}
        className={`edge-path ${isHighlighted ? 'persistent-highlight' : ''}`}
        stroke={isHighlighted ? '#4A90E2' : '#7F8C8D'}
        strokeWidth={isHighlighted ? 3 : 2}
        fill="none"
        markerEnd={`url(#${markerId})`}
        opacity={isHighlighted ? 1 : 0.6}
      />
      
      {/* Edge label (optional) */}
      {label && (
        <text
          x={(connectionPoints.start.x + connectionPoints.end.x) / 2}
          y={(connectionPoints.start.y + connectionPoints.end.y) / 2 - 5}
          className="edge-label"
          textAnchor="middle"
          fontSize="12"
          fill={isHighlighted ? '#4A90E2' : '#7F8C8D'}
        >
          {label}
        </text>
      )}
      
      {/* Message count badge */}
      {/* {messageCount > 0 && (
        <g>
          <circle
            cx={(connectionPoints.start.x + connectionPoints.end.x) / 2}
            cy={(connectionPoints.start.y + connectionPoints.end.y) / 2 + 10}
            r="12"
            fill={isHighlighted ? '#4A90E2' : '#3498DB'}
            stroke="white"
            strokeWidth="2"
          />
          <text
            x={(connectionPoints.start.x + connectionPoints.end.x) / 2}
            y={(connectionPoints.start.y + connectionPoints.end.y) / 2 + 15}
            textAnchor="middle"
            fontSize="10"
            fill="white"
            fontWeight="bold"
          >
            {messageCount}
          </text>
        </g>
      )} */}
    </g>
  );
}

export default GraphEdge;

